import { Container } from './styled';
export function Tab(props) {
    const { children, ...restProps } = props;
    return (
        <Container {...restProps}>
            {children}
        </Container>
    );
}           